(function () {
  app.controller('PricingCtrl', [
    "$scope", '$timeout',
    function ($scope, $timeout) {

      $scope.init = function () {
        addField($scope.business_plans)
        addField($scope.consumer_plans)
        $scope.showing_plans = $scope.business_plans;
      }

      $scope.plan_type = "business";
      $scope.plan_option = true;
      
      $scope.business_plans = [];
      $scope.consumer_plans = [];
      $scope.showing_plans = [];
      $scope.current_plan_id = null;
      $scope.current_plan_name = ""

      function addField(arr) {
        for (var i = 0; i < arr.length; i++) {
          var item = arr[i];
          if (item.id == $scope.current_plan_id) {
            item.btn_title = "Your current plan";
            item.btn_active = "active";
            item.btn_downgrade = true;
            continue;
          }

          if (item.id == null) {
            if ($scope.current_plan_id > 5) {
              item.btn_title = "Your current plan";
              item.btn_active = "active";
              item.name = $scope.current_plan_name;
              continue;
            } else {
              item.btn_title = "Contact Sales";
              continue;
            }
         
          }

          if (item.id < $scope.current_plan_id) {
            item.btn_title = "Dowgrade to " + item.name;
            item.btn_downgrade = true;
          } else {
            item.btn_title = "Upgrade to " + item.name;
          }
        }
      }
    
      $scope.selectPlanType = function(type){
        $scope.plan_type = type;
        if (type == "business") {
          addField($scope.business_plans);
          $scope.showing_plans = $scope.business_plans
        } else {
          addField($scope.consumer_plans);
          $scope.showing_plans = $scope.consumer_plans
        }
      }
   
    }
  ]);

}).call(this);